import {
  Avatar,
  Box,
  Flex,
  Icon,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
  useToast,
  HStack,
} from '@chakra-ui/react';

import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import { MdNotificationsNone } from 'react-icons/md';

const LogOutIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" x2="9" y1="12" y2="12"></line>
  </svg>
);

export default function HeaderLinks() {
  const toast = useToast();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const Username = localStorage.getItem('name');
  const role = localStorage.getItem('role');

  const userData = {
    name: Username,
    role: role === 'companyUser' ? 'Admin' : role,
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/auth/sign-in';
    toast({
      title: 'Logged out successfully',
      status: 'info',
      duration: 3000,
      isClosable: true,
    });
  };

  const textColor = useColorModeValue('gray.800', 'white');

  return (
    <Flex align="center" justify="flex-end" w="100%" gap={{ base: 2, md: 4 }}>
      {/* Notification */}
      <Flex
        w="40px"
        h="40px"
        align="center"
        justify="center"
        bg="gray.200"
        borderRadius="full"
        cursor="pointer"
      >
        <Icon as={MdNotificationsNone} w={5} h={5} />
      </Flex>

      {/* Profile */}
      <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)}>
        <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <HStack spacing={3}>
            <Avatar size="sm" name={userData.name} bg="gray.200" />

            <Box display={{ base: 'none', md: 'flex' }} flexDir="column">
              <Text fontWeight="semibold" fontSize="sm" color={textColor}>
                {userData.name}
              </Text>
              <Text fontSize="xs" color="gray.500" mt="-4px">
                {userData.role}
              </Text>
            </Box>
          </HStack>
        </MenuButton>

        <MenuList shadow="xl" borderRadius="lg" py={2}>
          <MenuItem
            icon={<LogOutIcon />}
            onClick={handleLogout}
            color="red.600"
          >
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
};
